import { BrowserRouter as Router, Route, Routes, Navigate, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthPage from "./pages/auth/AuthPage.js";
import GlobalHeader from "./components/globalHeader/globalHeader.js";
import QuestsPage from "./pages/quests/questsPage.js";
import RewardsPage from "./pages/rewards/rewardsPage.js";
import NotificationsPage from "./pages/notifications/notificationsPage.js";
import InvitesPage from "./pages/invites/invitesPage.js";
import PrivacyPolicy from "./pages/privacyPolicy/privacyPolicy.js";
import TermsOfService from "./pages/termsOfService/termsOfService.js";
import CommunitiesPage from "./pages/communities/communitiesPage.js";
import CommunityDetailPage from "./pages/communities/communityDetailPage.js";

import NavBar from "./components/navBar/navBar.js";
// import CodiBubbler from "./components/codiBubbler/codiBubbler.js";

import FronteraPage from "./pages/frontera/FronteraPage.js"; // Frontera Admin Dashboard
import UserHistory from "./pages/frontera/userHistory.js"; // Frontera Admin Dashboard User History
import ExplorePage from "./pages/explore/explorePage";
import CreateProject from "./pages/create/createProjectPage";
import AdminView from "./pages/projects/adminView/adminView";
import PublicView from "./pages/projects/publicView/publicView";
import TeamView from "./pages/projects/teamView/teamView";
import MessagesPage from "./pages/messages/messagesPage";
import UserPage from "./pages/user/userPage";
import Dashboard from "./pages/user/components/Dashboard/Dashboard.js";
import NotFoundPage from "./pages/notFoundPage.js";
import ActionHandler from "./pages/actionHandler/actionHandler.js";
import VerifyEmailPage from "./pages/verify/verifyEmailPage.js";
import ForgotPassword from "./pages/forgotPassword/forgotPassword.js";
import ResetPassword from "./pages/resetPassword/resetPassword.js";
import LandingPage from "./pages/landing/LandingPage.js";
import { authFetch } from "../src/utils/authFetch/authFetch.js";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-neutral-100">
      <Routes>
        {/* Global legal pages */}
        <Route path="/legal/privacy" element={<PrivacyPolicy />} />
        <Route path="/legal/terms" element={<TermsOfService />} />
        {/* (Login/Signup/Message pages) */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<AuthPage type="login" />} />
        <Route path="/signup" element={<AuthPage type="signup" />} />
        
        {/* Landing Page */}
        <Route path="/landing" element={<LandingPage />} />
        
        <Route
          path="/messages/:chatId"
            element={
              <ProtectedMessagesRoute
                component={() => (
                  <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                      <div style={{ display: "flex", height: "100%" }}>
                        <NavBar collapsed={false} setCollapsed={() => {}} />
                      <div style={{ flex: 1 }}>
                        <MessagesPage />
                      </div>
                  </div>
                </div>
              )}
            />
          }
        />

        {/* Frontera Admin Extension Handler */}
        <Route
          path="/fronteracloud/profile/frontera-dashboard"
          element={
            <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
              <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ flex: 1 }}>
                <FronteraPage />
              </div>
            </div>
          </div>
        }
      />

      <Route
        path="/fronteracloud/profile/frontera-dashboard/user-history"
          element={
            <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
              <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ flex: 1 }}>
                <UserHistory />
              </div>
            </div>
          </div>
        }
      />
    

        {/* Acion Handler */}
        <Route path="/action" element={<ActionHandler />} />

        {/* Verification Page */}
        <Route path="/verify-email" element={<VerifyEmailPage />} />

        {/* Forgot Password Page */}
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Reset Password Page */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Community Detail Page with GlobalHeader + NavBar */}
        <Route
          path="/communities/:communityId"
          element={
            <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
              <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
                <div
                  style={{
                    flex: 1,
                    transition: "margin-left 0.3s ease",
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  <CommunityDetailPage collapsed={collapsed} setCollapsed={setCollapsed} />
                </div>
              </div>
            </div>
          }
        />

        {/* Public View with GlobalHeader + NavBar */}
        <Route
          path="/projects/:projectId/details"
          element={
            <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
              <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
              <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
                <div
                  style={{
                    flex: 1,
                    // marginLeft: collapsed ? "70px" : "200px", // matches NavBar width
                    transition: "margin-left 0.3s ease",
                    height: "100%", // optional
                  }}
                >
                  <PublicView collapsed={collapsed} setCollapsed={setCollapsed} />
                </div>
              </div>
            </div>
          }
        />

        {/* Protected User Routes (GlobalHeader handled inside component) */}
        <Route
          path="/:username/*"
          element={<ProtectedUserRoutes collapsed={collapsed} setCollapsed={setCollapsed} />}
        />

        {/* Team View with GlobalHeader + NavBar */}
        <Route
          path="/projects/:projectId/collaborate"
          element={
            <ProtectedProjectRoute
              component={(props) => (
                <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                  <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
                  <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                    <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
                    <div
                      style={{
                        flex: 1,
                        // marginLeft: collapsed ? "70px" : "200px", // matches NavBar width
                        transition: "margin-left 0.3s ease",
                        height: "100%", // optional
                      }}
                    >
                      <TeamView {...props} collapsed={collapsed} setCollapsed={setCollapsed} />
                    </div>
                  </div>
                </div>
              )}
            />
          }
        />

        {/* Admin View with GlobalHeader + NavBar */}
        <Route
          path="/projects/:projectId/admin-view"
          element={
            <ProtectedProjectRoute
              component={(props) => (
                <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                  <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
                  <div style={{ display: "flex", height: "calc(100vh - 60px)" }}>
                    <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
                    <div
                      style={{
                        flex: 1,
                        // marginLeft: collapsed ? "70px" : "200px", // matches NavBar width
                        transition: "margin-left 0.3s ease",
                        height: "100%", // optional
                      }}
                    >
                      <AdminView {...props} collapsed={collapsed} setCollapsed={setCollapsed} />
                    </div>
                  </div>
                </div>
              )}
            />
          }
        />

        {/* 404 Fallback */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </div>
    </Router>
  );
  
}

const ProtectedMessagesRoute = ({ component: Component }) => {
  const [userIsValid, setUserIsValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = async () => {
      const token = localStorage.getItem("token");
      const email = localStorage.getItem("userEmail");
      if (!token || !email) return navigate("/login");

      try {
        const response = await fetch(`${BACKEND_URL}/user/${email}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error();
        setUserIsValid(true);
      } catch {
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    checkUser();
  }, [navigate]);

  if (loading) return <h1>Loading...</h1>;

  return userIsValid ? <Component /> : <Navigate to="/login" replace />;
};

/* Only Handles User Authentication */
const ProtectedUserRoutes = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [userIsValid, setUserIsValid] = useState(false);
  const [userData, setUserData] = useState(null);

  const location = useLocation();
  const { username } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
  const checkUser = async () => {
    try {
      const token = localStorage.getItem("token");
      const email = localStorage.getItem("userEmail");

      if (!token || !email) {
        navigate("/login");
        return;
      }

      const response = await authFetch(
        `${BACKEND_URL}/user/${email}`,
        { method: "GET" },
        navigate
      );

      const userData = await response.json();
      setUserData(userData);
      setUserIsValid(true);

    } catch (error) {
      console.error("❌ Error checking user authentication:", error);
    } finally {
      setIsLoading(false);
    }
  };

  checkUser();
}, [username, navigate]);

  if (isLoading) return <h1>Loading...</h1>;

  return userIsValid ? (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Top Header */}
      {location.pathname.endsWith("/messages") ? null : (
        <GlobalHeader collapsed={collapsed} setCollapsed={setCollapsed} />
      )}

      {/* Bottom content: sidebar + main */}
      <div style={{ display: "flex", flex: 1 }}>
        <NavBar collapsed={collapsed} setCollapsed={setCollapsed} />
        <div
          style={{
            flex: 1,
            // marginLeft: collapsed ? "70px" : "200px", // matches NavBar width
            transition: "margin-left 0.3s ease",
            height: "100%", // optional
          }}
        >
          <Routes>
            <Route path="explore" element={<ExplorePage collapsed={collapsed} setCollapsed={setCollapsed} user={userData} />} />
            <Route path="communities" element={<CommunitiesPage collapsed={collapsed} setCollapsed={setCollapsed} user={userData} />} />
            <Route path="create" element={<CreateProject collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="messages" element={<MessagesPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="profile" element={<UserPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="profile/dashboard" element={<Dashboard collapsed={collapsed} setCollapsed={setCollapsed} />}/>
            <Route path="quests" element={<QuestsPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="rewards" element={<RewardsPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="invites" element={<InvitesPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="notifications" element={<NotificationsPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
            <Route path="" element={<UserPage collapsed={collapsed} setCollapsed={setCollapsed} />} />
          </Routes>
        </div>
      </div>
    </div>
  ) : (
    <Navigate to="/login" replace />
  );
};

/* Handling Project Membership Inside `ProtectedProjectRoute` */
const ProtectedProjectRoute = ({ component: Component }) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [isAllowed, setIsAllowed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const checkProjectAccess = async () => {
    try {
      const token = localStorage.getItem("token");
      const email = localStorage.getItem("userEmail");

      if (!token || !email || !projectId) {
        navigate("/login");
        return;
      }

      const response = await authFetch(
        `${BACKEND_URL}/projects/${projectId}/access`,
        { method: "GET" },
        navigate
      );

      const { isAdmin, isTeamMember } = await response.json();
      if (isAdmin || isTeamMember) {
        setIsAllowed(true);
      } else {
        navigate(`/projects/${projectId}/details`);
      }
    } catch (error) {
      console.error("❌ Project access check failed:", error);
      navigate(`/projects/${projectId}/details`);
    } finally {
      setLoading(false);
    }
  };

  checkProjectAccess();
}, [projectId, navigate]);


  if (loading) return <h1>Loading...</h1>;

  return isAllowed ? <Component /> : <Navigate to={`/projects/${projectId}/details`} replace />;
};


export default App;
